import { useState } from "react";
import Sidebar from "./Sidebar";
import { Menu } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_2999b2bb-a766-4d2f-9d69-24fdb875566a/artifacts/5zlw12hm_fa-logo.png";

export default function AppLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen flex bg-[#FAFAFA]" data-testid="app-layout">
      {/* Mobile overlay backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-20 md:hidden"
          onClick={() => setSidebarOpen(false)}
          data-testid="sidebar-overlay"
          aria-hidden="true"
        />
      )}

      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="flex-1 min-w-0 flex flex-col">
        {/* Mobile-only top bar with hamburger */}
        <div className="md:hidden sticky top-0 z-10 bg-white border-b border-black/5 px-4 h-14 flex items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-md text-[#0A0A0A] hover:bg-[#F50E02]/10 hover:text-[#F50E02] transition-colors"
            data-testid="mobile-menu-button"
            aria-label="Open menu"
          >
            <Menu className="h-5 w-5" />
          </button>
          <div className="flex items-center gap-2">
            <div className="bg-black rounded-full p-0.5">
              <img src={LOGO_URL} alt="Sree LPG" className="h-6 w-6 object-contain" />
            </div>
            <span className="font-semibold text-sm text-[#0A0A0A]">
              Sree LPG <span className="text-[#F50E02]">Fuel Access</span>
            </span>
          </div>
        </div>

        <div className="flex-1 min-w-0">{children}</div>
      </main>
    </div>
  );
}
